import React from "react";

const ComplianceTab = () => (
  <h2 className="mt-5">Compliance</h2>
);

export default ComplianceTab;
